var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1917_368)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.625 11.1504C21.625 5.35144 16.924 0.650391 11.125 0.650391C5.32605 0.650391 0.625 5.35136 0.625 11.1504C0.625 16.3912 4.46472 20.7352 9.48438 21.5228V14.1855H6.81836V11.1504H9.48438V8.83711C9.48438 6.20555 11.052 4.75195 13.4503 4.75195C14.5992 4.75195 15.8008 4.95703 15.8008 4.95703V7.54102H14.4768C13.1723 7.54102 12.7656 8.35042 12.7656 9.18082V11.1504H15.6777L15.2122 14.1855H12.7656V21.5228C17.7853 20.7352 21.625 16.3913 21.625 11.1504Z",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2122 14.1855L15.6777 11.1504H12.7656V9.18082C12.7656 8.35034 13.1724 7.54102 14.4768 7.54102H15.8008V4.95703C15.8008 4.95703 14.5992 4.75195 13.4503 4.75195C11.052 4.75195 9.48438 6.20555 9.48438 8.83711V11.1504H6.81836V14.1855H9.48438V21.5228C10.0271 21.6079 10.5756 21.6505 11.125 21.6504C11.6744 21.6506 12.2229 21.6079 12.7656 21.5228V14.1855H15.2122Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1917_368"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white",
    transform: "translate(0.625 0.650391)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.39c74e191b20b8bd9863248b50634425.svg";
export { ForwardRef as ReactComponent };